import React from 'react';
import {useLockBodyScroll} from 'helpers';
import css from 'components/ui/popup/overlay.module.scss';

export function Overlay({ transition }) {
  useLockBodyScroll(transition != 'exited');
  return transition != 'exited' && (
    <div className={css('overlay', transition)} />
  );
}
